module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/logo_union_3004.png";